import React from "react";
import { Container, Box } from "@cloudscape-design/components";
import Icon from "@cloudscape-design/components/icon";
import { useNavigate } from "react-router-dom";
import SectionHeader from "../../common/SectionHeader";
import { Button } from "../../common/Button";
import ActivityTable from "../ActivityTable";
import { ROUTES } from "../../../constants";
import { ActivityItem } from "../../AllActivities/types";

interface RecentActivitySectionProps {
  items: ActivityItem[];
  loading?: boolean;
}

const RecentActivitySection: React.FC<RecentActivitySectionProps> = ({
  items,
  loading = false,
}) => {
  const navigate = useNavigate();

  return (
    <Box>
      <SectionHeader
        title="Recent Activity"
        variant="h2"
        icon={<Icon name="history" />}
        useGradient={true}
        actions={
          <Button
            variant="secondary"
            icon="angle-right"
            iconPosition="trailing"
            href={ROUTES.ACTIVITIES_ALL}
            size="small"
          >
            View all
          </Button>
        }
      />
      <Container>
        <ActivityTable items={items} loading={loading} />
      </Container>
    </Box>
  );
};

export default RecentActivitySection;
